import Constants from 'client/util/Constants';
import HIGHLIGHTS_CONSTS from './constants/highlightsConsts';

const { STATUS_FIELD, TIMESTAMP_FIELD, EVENT_FIELD } = HIGHLIGHTS_CONSTS;

const { dataNotAvailable } = Constants;

export const formatMetrics = (metrics, defaultFields = []) => {
  /**
   * Only show defaults and populated metrics
   */

  const formattedMetrics = Object.entries(metrics).reduce((populatedMetrics, [key, metric]) => {
    if (metric[TIMESTAMP_FIELD] || defaultFields.includes(key)) {
      populatedMetrics.push(
        {
          ...metric,
          [TIMESTAMP_FIELD]: metric[TIMESTAMP_FIELD] || dataNotAvailable,
          [STATUS_FIELD]: metric[STATUS_FIELD] || dataNotAvailable,
        },
      );
    }

    return populatedMetrics;
  }, []);

  /**
    * Ensure that the metrics are in alpabetical order
  */
  return formattedMetrics.sort((a, b) => {
    if (a[EVENT_FIELD] > b[EVENT_FIELD]) {
      return 1;
    }
    return -1;
  });
};

export default {
  formatMetrics,
};
